import i18n from "@/lang";
import newDateWrapper from "../new-date-wrapper/index"

// use locale fr-CA for format yyyy-mm-dd
export default function formatDate({ date, locale = i18n.locale === "ar" ? "ar-EG" : i18n.locale, options = {} }) {
  // date param types => should be 'date object' or 'string' or 'number'
  if (Number.isNaN(newDateWrapper(date).getTime())) {
    throw new TypeError("The date parameter is invalid")
  }
  return new Intl.DateTimeFormat(locale, options).format(newDateWrapper(date))
}
